import { getANMS, getBidderEmail, getBidderId, getUserFullName, isProfileComplete } from '@/redux/modules/user';
import { useEffect, useState } from 'react';
import { getIsBidderCardValid } from '@/redux/modules/bidderCardStatus';
import { getLogRocketAppId } from '@/redux/modules/config';
import LogRocketLib from 'logrocket';
import { useSelector } from 'react-redux';

// 90% chance of logging after 30 seconds | 10% chance of logging immediately
const logAfterTimeout = Math.random() <= 0.9;

/**
 * Initialize LogRocket client and identify the logged-in user
 * @see https://docs.logrocket.com/docs/getting-started
 */
const LogRocket = () => {
    const [startLogging, setStartLogging] = useState(false);

    // Get data to identify user
    const ANMS = useSelector(getANMS);
    const bidderId = useSelector(getBidderId);
    const creditCardValidated = useSelector(getIsBidderCardValid);
    const email = useSelector(getBidderEmail);
    const fullName = useSelector(getUserFullName);
    const profileComplete = useSelector(isProfileComplete);

    // Key to connect to LogRocket
    const logRocketAppId = useSelector(getLogRocketAppId);

    /**
     * Set flag to initialize LogRocket to start recording session
     */
    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;

        // Don't init LogRocket in local dev
        if (!__DEVELOPMENT__) {
            if (logAfterTimeout) {
                timer = setTimeout(() => {
                    setStartLogging(true);
                }, 30000);
            } else {
                setStartLogging(true);
            }
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    // Initialize LogRocket
    useEffect(() => {
        if (startLogging && bidderId > 0) {
            LogRocketLib.init(logRocketAppId);
        }
    }, [startLogging, bidderId, logRocketAppId]);

    // Identify User
    useEffect(() => {
        if (startLogging && bidderId > 0) {
            LogRocketLib.identify(bidderId.toString(), {
                ANMS,
                creditCardValidated,
                email,
                name: fullName,
                profileComplete,
            });
        }
    }, [ANMS, bidderId, creditCardValidated, email, fullName, logRocketAppId, profileComplete, startLogging]);

    return null;
};

export default LogRocket;
